"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var tokens_1 = require("../../tokens");
var heading_1 = __importDefault(require("../../atoms/heading"));
var description_1 = __importDefault(require("./description"));
var button_group_1 = __importDefault(require("../../molecules/button-group"));
var page_header_1 = require("../../_helpers/page-header");
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var button_prop_1 = __importDefault(require("../../_helpers/button-prop"));
var root_props_1 = require("../../_helpers/root-props");
var PageHeader = function (props) {
    return (React.createElement(PageHeader.Element, __assign({}, automation_attribute_1.default('page-header'), root_props_1.rootProps(props)),
        React.createElement(heading_1.default, { size: 1 }, props.title),
        React.createElement(PageHeader.Description, __assign({}, props)),
        (props.secondaryAction || props.primaryAction) && (React.createElement(button_group_1.default, null,
            button_prop_1.default(props.secondaryAction, { size: 'large', appearance: 'secondary' }),
            button_prop_1.default(props.primaryAction, { size: 'large', appearance: 'cta' })))));
};
PageHeader.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  @media (min-width: 768px) {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n  /*\n  Components should not have margin by default.\n  We'll remove this margin eventually\n  */\n  margin-bottom: ", ";\n\n  ", " {\n    margin-top: ", ";\n    @media (min-width: 768px) {\n      margin-top: 0;\n      margin-left: ", ";\n    }\n  }\n\n  ", " {\n    flex: 1;\n    /*\n    Components should not have margin by default.\n    We'll remove this margin reset when we remove margins from headers\n    */\n    margin: 0;\n  }\n"], ["\n  ", ";\n\n  @media (min-width: 768px) {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n  /*\n  Components should not have margin by default.\n  We'll remove this margin eventually\n  */\n  margin-bottom: ", ";\n\n  ", " {\n    margin-top: ", ";\n    @media (min-width: 768px) {\n      margin-top: 0;\n      margin-left: ", ";\n    }\n  }\n\n  ", " {\n    flex: 1;\n    /*\n    Components should not have margin by default.\n    We'll remove this margin reset when we remove margins from headers\n    */\n    margin: 0;\n  }\n"])), container_styles_1.default, tokens_1.spacing.large, button_group_1.default.Element, tokens_1.spacing.medium, tokens_1.spacing.small, heading_1.default.Element[1]);
PageHeader.Description = function (_a) {
    var description = _a.description, learnMore = _a.learnMore;
    if (!description) {
        return null;
    }
    if (page_header_1.descriptionIsObject(description)) {
        return React.createElement(description_1.default, null, description);
    }
    var descriptionCompat = { text: description, learnMore: learnMore };
    return React.createElement(description_1.default, null, descriptionCompat);
};
PageHeader.displayName = 'Page Header';
PageHeader.defaultProps = {
    title: ''
};
var StyledPageHeader = PageHeader.Element;
exports.StyledPageHeader = StyledPageHeader;
exports.default = PageHeader;
var templateObject_1;
//# sourceMappingURL=page-header.js.map